// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import { GetWarehousesApiParameter } from "@insite/client-framework/Services/WarehouseService";
import loadWarehouses from "@insite/client-framework/Store/Components/FindLocationModal/Handlers/LoadWarehouses";
import loadCurrentCountries, {
    loadCurrentCountriesParameter,
} from "@insite/client-framework/Store/Data/Countries/Handlers/LoadCurrentCountries";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page from "@insite/mobius/Page";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapDispatchToProps = {
    loadCurrentCountries,
    loadWarehouses,
};

type Props = PageProps & ResolveThunks<typeof mapDispatchToProps>;

const RequestAccess = ({ id, loadCurrentCountries, loadWarehouses }: Props) => {
    const getWarehousesParameter: GetWarehousesApiParameter = {
        search: "",
        latitude: 0,
        longitude: 0,
        pageSize: 20,
    };
    useEffect(() => {
        loadCurrentCountries();
        loadWarehouses(getWarehousesParameter);
    }, []);

    return (
        <Page>
            <Zone contentId={id} zoneName="Content"></Zone>
        </Page>
    );
};

const pageModule: PageModule = {
    component: connect(null, mapDispatchToProps)(RequestAccess),
    definition: {
        hasEditableUrlSegment: false,
        hasEditableTitle: true,
        pageType: "System",
    },
};

export default pageModule;

export const RequestAccessPageContext = "RequestAccessPage";
